import { NewApplicationStatus } from '../../../../hoc/new-application/types';

import cn from '../overview.module.css';

// eslint-disable-next-line import-x/prefer-default-export
export const getCofApplicationStatus = (status: NewApplicationStatus) => {
  let applicationStatus: string;
  let applicationStatusClassName = cn.cofDefault;

  switch (status) {
    case NewApplicationStatus.ACCEPTED:
      applicationStatus = 'Accepted';
      applicationStatusClassName = cn.cofApproved;
      break;
    case NewApplicationStatus.DECLINED:
      applicationStatus = 'Declined';
      applicationStatusClassName = cn.cofRejeted;
      break;
    case NewApplicationStatus.INCOMPLETE:
      applicationStatus = 'Incomplete';
      break;
    case NewApplicationStatus.READY_TO_REVIEW:
      applicationStatus = 'Ready to Review';
      applicationStatusClassName = cn.cofReadyToReview;
      break;
    case NewApplicationStatus.REVIEW_IN_PROGRESS:
      applicationStatus = 'Review in Progress';
      applicationStatusClassName = cn.cofReadyToReview;
      break;
    default:
      applicationStatus = status;
      break;
  }

  return { applicationStatus, applicationStatusClassName };
};
